import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TransformYourAtmosphere from "./sections/TransformYourAtmosphere";
import Corporateeventlogistics from "./sections/Corporateeventlogistics";
import HowItWorksProcess from "./sections/HowItWorksProcess";
import Conversionfocuscta from "./sections/Conversionfocuscta";
import HongKongweathertimewidget from "./sections/HongKongweathertimewidget";
import NuestraPropuestaDeValor from "./sections/NuestraPropuestaDeValor";
import ArtisticMilestones from "./sections/ArtisticMilestones";
import DesignThinkingInsights from "./sections/DesignThinkingInsights";
import ReadyForATestDrive from "./sections/ReadyForATestDrive";
import Featuredservices from "./sections/Featuredservices";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TransformYourAtmosphere />
      <HowItWorksProcess />
      <Corporateeventlogistics />
      <NuestraPropuestaDeValor />
      <HongKongweathertimewidget />
      <Featuredservices />
      <ArtisticMilestones />
      <DesignThinkingInsights />
      <ReadyForATestDrive />
      <Conversionfocuscta />
      <Footer />
    </div>;
}